import { createContext, useContext } from "react";

import type { GoogleFreeBookingLinksSettingsI18nZodSchemaType } from "../../../hooks";
import type { UseFormReturn } from "react-hook-form";

export type GoogleFreeBookingLinksSettingsI18nContextType = {
	form: UseFormReturn<GoogleFreeBookingLinksSettingsI18nZodSchemaType>;
};

export const GoogleFreeBookingLinksSettingsI18nContext = createContext<GoogleFreeBookingLinksSettingsI18nContextType>(
	null!,
);

export const useGoogleFreeBookingLinksSettingsI18nContext = () => {
	const context = useContext(GoogleFreeBookingLinksSettingsI18nContext);

	if (!context) {
		throw new Error("GoogleFreeBookingLinksSettingsI18nContext is not defined");
	}

	return context;
};
